import { useMemo } from 'react';

import { gql } from '@apollo/client';
import { useTranslation } from '@modernloop/i18n';
import { FunctionWithFragments } from '@modernloop/shared/components';
import { MenuItemProps } from '@mui/material';

import { InterviewModuleMemberMenuOptionsFragment, TrainingStatus } from 'src/generated/mloop-graphql';

export enum MoreMenuOptions {
  Delete = 'Delete',
  SET_AS_TRAINEE = 'SET_AS_TRAINEE',
  SET_AS_TRAINED = 'SET_AS_TRAINED',
}

export const useInterviewModuleMemberMenuOptions: FunctionWithFragments<
  { moduleMember: InterviewModuleMemberMenuOptionsFragment | undefined },
  undefined,
  MenuItemProps[] | undefined
> = ({ moduleMember }) => {
  const { t } = useTranslation();
  return useMemo(() => {
    if (!moduleMember) {
      return undefined;
    }

    const options: MenuItemProps[] = [];

    if (moduleMember.status === TrainingStatus.Trained) {
      options.push({
        id: MoreMenuOptions.SET_AS_TRAINEE,
        value: t('hiring-dashboard-interviewers:interviewers.moduleMemberMenu.setAsTrainee'),
      });
    } else {
      options.push({
        id: MoreMenuOptions.SET_AS_TRAINED,
        value: t('hiring-dashboard-interviewers:interviewers.moduleMemberMenu.setAsTrained'),
      });
    }

    options.push({
      id: MoreMenuOptions.Delete,
      value: t('hiring-dashboard-interviewers:interviewers.moduleMemberMenu.removeFromModule'),
      color: 'error',
    });

    return options;
  }, [moduleMember, t]);
};

useInterviewModuleMemberMenuOptions.fragments = {
  moduleMember: gql`
    fragment InterviewModuleMemberMenuOptions on InterviewModuleMember {
      employeeId
      interviewModuleId
      status
    }
  `,
};
